import React from 'react'
import PropTypes from 'prop-types'

import { constants } from 'helpers'
import { Button } from 'components'

const {
  ROUTES: { LANDING },
} = constants

const MoreFromHostButton = ({ history }) => (
  <Button className="w-34 bg-black md:w-full text-base" onClick={() => history.push(LANDING)}>
    This event is over
  </Button>
)

MoreFromHostButton.propTypes = {
  classes: PropTypes.string,
  linkId: PropTypes.string,
  hostName: PropTypes.string,
  history: PropTypes.object,
}

export default MoreFromHostButton
